import {HTMLAttributes, PropsWithChildren, useEffect, useRef} from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
    onChildrenChange: () => void;
}

const ObserveChildren = ({onChildrenChange, children, ...props}: PropsWithChildren<Props>) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // observe when children have rendered to run callback
        const observer = new MutationObserver(() => {
            onChildrenChange();
        });

        if (containerRef.current) {
            observer.observe(containerRef.current, {childList: true, subtree: true});
        }

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div {...props} ref={containerRef}>
            {children}
        </div>
    );
};

export default ObserveChildren;
